<template>
    <div>
        <div class="container">
            <h2 class="china_title" v-animate="'fade-in-1'">Singapore</h2>
            <p class="china_text" v-animate="'fade-in-2'">グローバル企業のASEAN地域HQが集まるシンガポール。日本人も3万人以上が住んでおり、高い購買力を求めECサイトを通じての商品販売が活況です。</p>
            <SingaporeList />
            <p class="china_note"><a href="#" class="china_note_anchor" v-b-modal.modal-2>※本ページの各国の数値、グラフ等のコンテンツは出典を元に株式会社オロ作成。<span class="china_note_icon"><img src="../../assets/icons/china.svg" alt="i"></span></a></p>
            <b-modal id="modal-2" title="" hide-footer centered>
                <div class="d-block" v-html="modal_content">
                </div>
            </b-modal>
        </div>
        <OurWork  country="SP"/>
        <News category="Singapore"/>
        <SingaporeMaps />
        <div class="china_work">
            <section class="our_works">
                <div class="bottom d-flex align-items-center justify-content-center">
                    <a class="link-full" href="/global/contactus/"></a>
                    <a class="btn fw-bold btn-with-arrow"><span>お問い合わせ</span></a>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import SingaporeList from "../../components/location/SingaporeList";
import OurWork from "../../components/location/OurWork";
import News from "../../components/location/News";
import SingaporeMaps from "../../components/location/SingaporeMaps";
export default {
    name: 'WorksContent',
    components: {
        SingaporeList,
        OurWork,
        News,
        SingaporeMaps
    },
    data() {
        return {
            modal_content: '<p>※本ページの各国の数値、グラフ等のコンテンツは出典を元に株式会社オロ作成。</p>' +
                '<ul><li>（出典）</li>' +
                '<li>United Nations　World Population</li>' +
                '<li>外務省　海外在留邦人数調査統計　2021年</li>' +
                '<li>JETRO　台湾　概況・基本統計　2021年</li>' +
                '<li>JETRO　香港　概況・基本統計　2021年</li>' +
                '<li>日本国外務省「海外進出日系企業拠点数調査」2020年調査結果</li>' +
                '<li>National Bureau of Statictics of China　CHINA STATISTICAL YEAER BOOK 2020</li>' +
                '<li>The government of the Hong Kong Special Administrative Region. Registered Non-Hong Kong Companies in 2021</li>' +
                '<li>JETRO　ビジネス短信　「2019年の香港域外企業の香港拠点に関する調査報告」</li>' +
                '<li>Twimbit analysis</li>' +
                '<li>JETRO　マレーシア　概況・基本統計　2021年</li>' +
                '<li>Government of Singapore　STATICTICS SINGAPORE</li>' +
                '<li>JETRO　ビジネス短信「在タイ日系企業数が5,856社に、前回調査から412社増加」</li>' +
                '<li>Badan Pusat Statistik</li>' +
                '<li>kumparan Bisnis</li>' +
                '<li>Republic of Philippines Securities and Exchange Comission</li>' +
                '<li>Accounting and Corporate Regulatory Authority Business Registry Statistics</li>' +
                '<li>Government of Vietnam GENERAL STATICS OFFICE</li>' +
                '<li>Department of Commerce, MOEA. COMMERCE INDUSTRIAL SERVICE PORTAL</li>' +
                '<li>THE WORLD BANK</li>' +
                '<li>JETRO　香港　概況・基本統計　2021年</li>' +
                '<li>ZENITH MEDIA Advertising-Expenditure-Forecasts</li></ul>'
        }
    }
}
</script>

<style lang="scss" scoped>
    .china_title {
        font-size: 55px;
        margin-bottom: 27px;
    }

    .china_text {
        font-size: 20px;
        font-weight: 500;
        line-height: 1.7;
        margin-bottom: 73px;
    }

    .china_pagenavi {
        border-top: 1px solid #eeeeee;
        background: url('../../assets/location/bg-location.png') no-repeat left center;
        background-size: cover;
        padding: 92px 7.3% 70px 0;
        transition: all 0.3s;

        &:hover {
           background: url('../../assets/location/bg-location_on.png') no-repeat left center;
           background-size: cover;
        }

        &_anchor {
            justify-content: flex-end;
            flex-wrap: wrap;
            color: #000000;

            &:hover {
                .china_pagenavi_area::after {
                    right: 0;
                }
            }
        }

        &_text {
            width: 100%;
            line-height: 1.875;
            text-align: right;
        }

        &_area {
            font-size: 28px;
            font-weight: 500;
            justify-content: flex-end;
            padding-right: 104px;
            margin-bottom: 32px;
            position: relative;

            &::after {
               content: '';
               display: inline-block;
               width: 71px;
               height: 13px;
               background: url('../../assets/icons/arrow-right-dark.svg') no-repeat right center;
               background-size: cover;
               position: absolute;
               right: 9px;
               top: 2px;
               transition: all 0.3s;
            }
        }

    }

    .china_icon {
        display: block;
        width: 50px;
        font-weight: 500;
        font-size: 16px;
        text-align: center;
        line-height: 1.1;
        padding-top: 1px;
        margin-right: 22px;
        border: 1px solid #000000;
    }

    .china_work .our_works {
        height: 328px;
        max-height: 100vh;

        .bottom {
            background: #DDDDDD;
            height:100%;
            position: relative;
            transition: background-color .3s ease-in-out;
            background: linear-gradient(to left, #DDDDDD 50%, #FFBC07 50%) right;
            background-size: 200%;
            transition: background-position .3s ease-in-out;
            &:hover {
                background-position: left;
                .btn-with-arrow {
                    background: #FFBC07;
                    span {
                        color: #000;

                        &:after {
                            background: url(../../assets/icons/arrow-right-dark.svg) no-repeat right center;
                            transform: translateX(10px);
                        }
                    }
                }
            }
        }

        .work-area-group {
            margin-top: auto;
            transform: translateY(40px);
            z-index: 12;
        }
    }

    .china_note {
        font-size: 14px;
        margin-bottom: 94px;
        text-indent: -1em;
        padding-left: 2em;

        &_anchor {
            color: #000;
            display: inline-block;
        }
    }

    .btn-with-arrow {
        background: #000;
        width: 387px;
        height: 90px;
        border-radius: 0;
        display: flex;
        justify-content: center;
        align-items: center;

        span {
            color: #fff;
            font-size: 28px;
            letter-spacing: 1.4px;
            line-height: 40px;
            font-weight: bold;
            display: block;

            &:after {
                content: "";
                display: inline-block;
                width: 71px;
                height: 13px;
                background: url(../../assets/icons/arrow-right.svg) no-repeat right center;
                margin-left: 1rem;
                transition: transform .3s ease-out;
            }
        }
    }

    .animate {
        opacity: 0;
    }

    .animate-active.fade-in-1 {
        animation: fade-in .5s linear;
        animation-fill-mode: forwards;
    }

    .animate-active.fade-in-2 {
        animation: fade-in .5s linear;
        animation-fill-mode: forwards;
        animation-delay: .5s;
    }

    .animate-active.fade-in-3 {
        animation: fade-in 1s linear;
        animation-fill-mode: forwards;
        animation-delay: 1s;
    }

    @media screen and (max-width: 991px) {
        .our_works {
            height: auto;
            max-height: none;

            .bottom {
                height: 250px;
            }
        }
    }

    @media screen and (max-width: 767px) {
        .china_pagenavi {
            background: url('../../assets/location/bg-location_sp.png') no-repeat 35% center;
            background-size: cover;
            padding: 57px 10% 61px 10%;
        }
        .btn-with-arrow {
            height: 70px;
            padding: 1rem 3rem;
            width: auto;
        }
        .btn-with-arrow span {
            font-size: 22px;
            letter-spacing: .88px;
            line-height: 31px;
            &::after {
                width: 56px;
            }
        }

        .china_note {
            margin-bottom: 54px;
        }
    }

    @media screen and (max-width: 400px) {
        .btn-with-arrow {
            padding: .5rem 1rem;
        }

        .china_pagenavi {
            background: url('../../assets/location/bg-location_sp.png') no-repeat 41% center;
            background-size: cover;
        }
    }
</style>
